<template>
    <div class="comments-section no-print" >
        <div class="title-block" v-show="comments.length > 0">
            <h5 class="title-5">Comments from donors</h5>
        </div>
        <ul v-for="comment in comments" v-bind:key="comment.id" class="donors-list" v-show="comments.length > 0">
            <li>
                <div class="image-block">
                    <!--<img src="/images/content/comment-avatar.png" :alt="comment.author" class="rounded-circle float-left">-->
                    <img :src="comment.avatar_url" :alt="comment.author" class="rounded-circle float-left">
                </div>
                <div class="comments">
                    <h6 class="title-6">{{comment.name}}</h6>
                    <p class="paragraph">{{comment.body}}</p>
                </div>
            </li>
        </ul>
        <div class="row">
            <div class="col-12">
                <div class="input">
                    <textarea v-model="comment" :class="payloadError? 'input-field red-hover' : 'input-field'"
                              :placeholder="textareaPlaceholder"
                              :disabled="user===null"
                              rows="5" type="text" width="100%"></textarea>
                </div>
                <!--<span v-show="payloadErrors.comment"-->
                <!--class="text-danger">Please enter your comment</span>-->
            </div>
        </div>
        <div class="single-row" style="margin-top: 10px;">
            <button :class="user===null? 'solid-btn disabled': 'solid-btn'"
                    @click="saveComment"
                    :disabled="user===null">Comment</button>
        </div>
        <br>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.getComments();
        },
        props: {
            fundraiserId: {
                type: Number,
                required: true
            },
            user:{
                required: true,
            },
        },
        data() {
            return {
                comments: {},
                comment:'',
                validating:false,
            }
        },
        computed:{
            textareaPlaceholder(){
                return this.user!== null ? "Leave your comment here..." : "you must be login to comment..."
            },
            payloadError(){
                return this.validating && this.comment.trim() === "";
            },
            commentStoreRoute(){
                return window.App.globalData.routes.comments_store.replace('FID',this.fundraiserId);
            },
            commentGetRoute(){
                return window.App.globalData.routes.fundraiser_comments.replace('FID',this.fundraiserId);
            }
        },
        methods:{
            getComments(){
                window.axios.get(this.commentGetRoute)
                    .then((response) => {
                        this.comments = response.data.data;
                    });
            },
            saveComment(){
                if(this.validate()){
                    axios.post(this.commentStoreRoute,{
                        body: this.comment.trim(),
                        fundraiser_id: this.fundraiserId,
                    }).then(response=>{
                        this.resetComment();
                        this.getComments();
                        this.$notify({
                            title: 'Success',
                            message: response.data.response.message,
                            type: 'success'
                        });
                    }).catch(e=>{
                        console.error(e);
                        this.$notify({
                            title: 'Error',
                            message: "Something was wrong please reload the page and try again",
                            type: 'error'
                        });
                    })
                }
            },
            validate(){
                this.validating = true;
                return !this.payloadError;
            },
            resetComment(){
                this.validating = false;
                this.comment = "";

            }
        }

    }
</script>

<style>
    .comments > .title-6 {
        word-break: break-all;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/DonatorsComments.vue